import { configureStore } from '@reduxjs/toolkit'
import {
    useDispatch as useReduxDispatch,
    useSelector as useReduxSelector
} from 'react-redux'
import { createLogger } from 'redux-logger/src'
import dmReducer from '@/slices/dm'
import mapReducer from '@/slices/map'

const ignoredActions = ['map/onChangeViewport']

const store = configureStore({
    reducer: {
        dm: dmReducer,
        map: mapReducer
    },
    middleware: (getDefaultMiddleware) => {
        const base = getDefaultMiddleware()
        if (import.meta.env.DEV) {
            return base.concat(
                createLogger({
                    predicate: (getState, action) =>
                        !ignoredActions.includes(action.type),
                })
            )
        }
        return base
    },
    devTools: import.meta.env.VITE_ENABLE_REDUX_DEV_TOOLS === 'true'
})

export const useSelector = useReduxSelector

export const useDispatch = () => useReduxDispatch()

export default store
